<template>
  <div class="leftpart">
    <div class="leftpart_inner">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/img/logo/dark.png" alt="" />
        </router-link>
      </div>
      <!-- End .logo -->
      <div class="menu">
        <MenuItem text="Home" link="/" :icon="home" />
        <!-- <MenuItem text="About" link="about" :icon="avatar" /> -->
        <MenuItem text="Experiences" link="experiences" :icon="avatar" />
        <!-- <MenuItem text="Portfolio" link="portfolio" :icon="avatar" /> -->
        <!-- <MenuItem text="News" link="news" :icon="avatar" /> -->
        <!-- <MenuItem text="Contact" link="contact" :icon="avatar" /> -->
      </div>
      <div class="copyright">
        <div>
          <span> {{ new Date().getFullYear() }} Ahmed Allam.<br /> </span>
          <span class="relative">
            <span style="padding-right: 26px"> Crafted with </span>
            <span class="heart"></span>
            <span> by me </span>
          </span>
        </div>
      </div>
      <!-- End copyright -->
    </div>
  </div>
  <!-- End leftpart -->

  <!-- Start rightpart -->
  <div class="rightpart">
    <div class="rightpart_in">
      <div class="theme_a_section">
        <div class="container">
          <div class="tabcontent">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MenuItem from "./components/menuItem.component.vue";
import avatar from "@/assets/img/svg/avatar.svg";
import home from "@/assets/img/svg/home-run.svg";

@Options({
  components: {
    MenuItem,
  },
})
export default class MainLayout extends Vue {
  avatar = avatar;
  home = home;
}
</script>

<style lang="scss" scoped>
.heart {
  width: 100px;
  height: 100px;
  position: absolute;
  /* display: block; */
  left: 50px;
  top: -3px;
  transform: translate(-0, -10px) scale(0.5);
  transform-origin: top;
  background: url(https://cssanimation.rocks/images/posts/steps/heart.png) no-repeat;
  background-position: 0 0;
  cursor: auto;
  animation: fave-heart-data-v-235a91a6 1s steps(28);
}

.heart:hover {
  background-position: -2800px 0;
  transition: background 1s steps(28);
}

@keyframes fave-heart {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: -2800px 0;
  }
}

.leftpart {
  width: 450px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  z-index: 10;
  padding: 0px 100px;
  background-color: #fff;

  @media screen and (max-width: 1200px) {
    position: fixed;
    width: 100%;
    height: auto;
    padding: 0;
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 10;
    background-color: #fff;
    box-shadow: 0 10px 40px 0 rgba(12, 68, 25, 0.1);
  }
}

.leftpart_inner {
  width: 100%;
  height: auto;
  @media screen and (max-width: 1200px) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px;
  }
  @media screen and (max-width: 420px) {
    padding: 20px 15px;
  }
}

.leftpart img {
  max-width: 150px;
  @media screen and (max-width: 1200px) {
    max-width: 100px;
  }
}

.leftpart .menu {
  padding: 40px 0px 50px 0px;
  width: 100%;
  float: left;
  margin: 0px;
  list-style-type: none;
  @media screen and (max-width: 1200px) {
    padding: 0;
    width: auto;
    float: none;
    display: inline-flex;
    flex-direction: row;
    ul {
      display: flex;
      align-items: center;
    }
    a {
      .svg {
        display: block;
      }
      .menu_content {
        display: none;
      }
      &:not(:last-child) {
        margin-right: 15px;
      }
      &.react-tabs__tab--selected {
        filter: invert(0.4);
      }
    }
  }
}


.leftpart .copyright {
  width: 100%;
  float: left;
  @media screen and (max-width: 1200px) {
     display: none;
  }
}

.leftpart .copyright p {
  font-size: 15px;
  color: #999;
  font-family: "Montserrat";
  line-height: 25px;
  font-style: italic;
}

.leftpart .copyright a {
  text-decoration: none;
  color: #787878;
  font-weight: 500;
  padding-left: 5px;

  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.leftpart .copyright a:hover {
  color: #000;
  letter-spacing: 2px;
}


.container {
  max-width: 1150px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  padding: 0px 40px;
  position: relative;
  clear: both;
  @media screen and (max-width: 1200px){
    padding: 0px 10px;
  }
}

.theme_a_all_wrap .rightpart {
  @media (max-width: 1200px) {
    padding-left: 0px;
  }
  width: 100%;
  min-height: 100vh;
  float: left;
  position: relative;
  background-color: #f8f8f8;
  padding-left: 450px;
}
.theme_a_all_wrap .rightpart_in {
  @media (max-width: 1200px) {
    border-left: none;
  }
  position: relative;
  width: 100%;
  float: left;
  clear: both;
  min-height: 100vh;
}
.theme_a_mobile_menu {
  display: block;
}
.theme_a_section {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  margin-left: 450px;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 99;
  @media screen and (max-width: 1199px) {
    z-index: 1;
    margin-left: 0px;
  }
}
.theme_a_section .react-tabs__tab-panel {
  transform: translate3d(10%, 0, 0);
  transition: transform 0.5s ease;
}
.theme_a_section .react-tabs__tab-panel--selected {
  transform: translate3d(0, 0, 0);
}
</style>
